import * as _ from 'lodash';
import { ActionType } from './actions';
import { IAAPDEvent } from '../../classes/event';
import axios, { AxiosResponse } from 'axios';
import { Dispatch } from "react-redux";
import { CalendarAppState } from "../../classes/redux-states";



function requestEvents() {
    return {
        type: ActionType.REQUEST_NEXT_BATCH
    }
}

function eventsResponse(response: IAAPDEvent[]) {
    return {
        type: ActionType.RECEIVE_NEXT_BATCH,
        value: {
            events: response
        }
    }
}

function getEventsCall(month: number, year: number) {
    return axios.get<IAAPDEvent[]>('/api/v1/calendar/calendar',
            {
                params: {
                    month: month,
                    year: year
                }
            })
}

export function getEvents(isListView: boolean) {
    return (dispatch: Dispatch<CalendarAppState>, getState: () => CalendarAppState) => {
        let state = getState();
        dispatch(requestEvents());
        axios.get<IAAPDEvent[]>('/api/v1/calendar/calendar',
            {
                params: {
                    month: state.calendarApiModel.selectedDate.month(),
                    year: state.calendarApiModel.selectedDate.year(),
                    isListView: isListView
                }
            }).then(response => {
                const eventList = response.data

                state = getState();
                if (state.calendarApiModel.selectedCategory != "allcategories") {
                    const filteredEvents = eventList.filter(event => state.calendarApiModel.selectedCategory === event.eventCategory);
                    dispatch(eventsResponse(filteredEvents));
                } else {
                    const filteredEvents = response;
                    dispatch(eventsResponse(response.data));
                }
            })
    }
}






// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/redux/actions/calendar-api.ts